import { useEffect, useRef, useState } from 'react';
import { PersonalizeType } from '@portalCommon/constants';
import { useYaotaiGlobalContextState } from '@commonPackage/contexts';
import {
  PointBurLEnumPortal,
  sendEventAndRedirectToConsultWitchParams,
  toDemoCloudGamePageWithTourist,
} from 'portal-common/src/utils';
import classnames from 'classnames/bind';
import { useInViewport } from '@fuxi/eevee-hooks';
import { DEFAULT_IMG } from 'common-package';
import { OptimizedImg } from '@commonPackage/components';
import styles from './index.module.less';

const cx = classnames.bind(styles);

interface MatchProps {
  title: string;
  desc: string[];
  choseMenus: ChoseListItem[];
  side: PersonalizeType;
  thumb?: string;
  video?: string | null;
}

export interface ChoseListItem {
  previewMan: string;
  previewWoman: string;
  displayMan: string;
  displayWoman: string;
}

enum Sex {
  Male,
  Female,
}

const DISPLAY_PIC_MAP: {
  [key: string]: string;
} = {
  [PersonalizeType.Face]: 'display-pic-face',
  [PersonalizeType.Hair]: 'display-pic-hair',
  [PersonalizeType.Cloth]: 'display-pic-cloth',
  [PersonalizeType.Action]: 'display-pic-action',
};

const DISPLAY_PIC_HEIGHT_MAP: {
  [key: string]: number;
} = {
  [PersonalizeType.Face]: 400,
  [PersonalizeType.Hair]: 400,
  [PersonalizeType.Cloth]: 650,
  [PersonalizeType.Action]: 0,
};

const Match = (props: MatchProps) => {
  const { title, desc, choseMenus, video, side, thumb } = props;
  const [previewIndex, setPreviewIndex] = useState(0);
  const [sex, setSex] = useState(Sex.Male);
  const [currentStyle, setCurrentStyle] = useState(() => {
    return DISPLAY_PIC_MAP[side];
  });
  const previewRef = useRef<HTMLDivElement>(null);
  const [isInViewport] = useInViewport(previewRef, {
    rootMargin: '600px',
  });
  const {
    commonUrls: { demoAid },
  } = useYaotaiGlobalContextState();
  const isVideo = !!video;

  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    videoRef.current?.play?.();
  }, [isVideo]);

  const handleChangeSex = (param: Sex) => {
    setSex(param);
  };

  return (
    <div className={cx('container')} ref={previewRef}>
      <div className={cx('left-menus')}>
        <div className={cx('title')}>{title}</div>
        <div className={cx('line')} />
        <ul className={cx('text-item-container')}>
          {desc.map(item => (
            <li className={cx('text-item', { 'text-item-action': isVideo })} key={item}>
              {item}
            </li>
          ))}
        </ul>

        {/* 衣服缩略图选择区 */}
        {!isVideo && (
          <div className={cx('preview-container')}>
            {choseMenus.map(({ previewMan, previewWoman }, index) => (
              // eslint-disable-next-line jsx-a11y/alt-text
              <div
                key={index}
                onMouseEnter={() => {
                  setPreviewIndex(index);
                }}
                className={cx('preview-card', previewIndex === index ? 'preview-card-chosen' : '')}
                style={{
                  backgroundImage: isInViewport
                    ? `url(${sex === Sex.Male ? `${previewMan}` : `${previewWoman}`})`
                    : `url(${DEFAULT_IMG})`,
                }}
              />
            ))}
            <div className={cx('preview-card-hold')} />
          </div>
        )}

        <div className={cx('btn-container')}>
          <button
            className={cx('free-enjoy')}
            onClick={() => {
              toDemoCloudGamePageWithTourist(demoAid);
            }}>
            免费体验
          </button>
          <div
            className={cx('consult')}
            onClick={() => {
              sendEventAndRedirectToConsultWitchParams(PointBurLEnumPortal.VirtualAvatarConsult);
            }}>
            方案咨询
          </div>
        </div>
      </div>

      <div className={cx('right-display')}>
        {isVideo ? (
          <div key="video" className={cx('content-box')}>
            <div className={cx('video-box')}>
              <video src={video} preload="metadata" poster={thumb} muted loop ref={videoRef} />
            </div>
          </div>
        ) : (
          <div>
            {choseMenus.map(({ displayMan, displayWoman }, index) => {
              return (
                <>
                  <OptimizedImg
                    alt=""
                    key={index}
                    style={{
                      display: previewIndex === index && sex === Sex.Male ? 'inline-block' : 'none',
                    }}
                    height={DISPLAY_PIC_HEIGHT_MAP[side]}
                    className={cx(`${currentStyle}`, { 'display-pic': true })}
                    onLoad={() => {
                      setCurrentStyle(DISPLAY_PIC_MAP[side]);
                    }}
                    src={displayMan}
                  />
                  <OptimizedImg
                    alt=""
                    key={index}
                    style={{
                      display: previewIndex === index && sex === Sex.Female ? 'inline-block' : 'none',
                    }}
                    height={DISPLAY_PIC_HEIGHT_MAP[side]}
                    className={cx(`${currentStyle}`, { 'display-pic': true })}
                    onLoad={() => {
                      setCurrentStyle(DISPLAY_PIC_MAP[side]);
                    }}
                    src={displayWoman}
                  />
                </>
              );
            })}
            <div className={cx('sex')}>
              <div
                className={cx('sex-common', sex === Sex.Male ? 'male-selected' : 'male')}
                onClick={() => handleChangeSex(Sex.Male)}>
                男
              </div>
              <div
                className={cx('sex-common', sex === Sex.Female ? 'female-selected' : 'female')}
                onClick={() => handleChangeSex(Sex.Female)}>
                女
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Match;
